<app-material>
    <ng-container header>
        <div class="header">
            <h2>{{ 'admin.equipment.table.title' | translate }}</h2>
            <div class="mutators">
                <app-button *ngIf="shouldRenderModifiers()"
                            (clicked)="openEquipmentModal()">{{ 'admin.equipment.buttons.addEquipment' | translate }}
                </app-button>

                <app-button style="float: right"
                            (clicked)="onDownloadEquipReport()">
                    {{ 'reportDownloadForm.downloadButton' | translate }}
                </app-button>
            </div>
        </div>
    </ng-container>
    <ng-container body>
        <app-equipment-table [equipment]="equipment"
                             [tableConfig]="tableConfig"
                             [isLoading]="isLoadingEquipment"
                             [headerBackgroundColor]="'rgba(162, 186, 210, .3)'"
                             [hasTitle]="false"
                             (sortChange)="onSortChange($event)"
                             (filterChange)="onFilter($event)"
                             (rowClick)="onTableRowClick($event)"
                             (duplicate)="onDuplicateRow($event)"
                             (pageChange)="onPageChange($event)">
        </app-equipment-table>
    </ng-container>
    >
</app-material>
<app-equipment-create-modal
    [isLoading]="isLoadingEquipment"
    (onCreate)="createEquipment($event)"
    (onUpdate)="updateEquipment($event)"
    (onDelete)="deleteEquipment($event)">
</app-equipment-create-modal>
